const isEmail = email => {
    const regex = /^([a-zA-Z0-9_.\-+])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!regex.test(email)) {
            return false;
        }
        else {
            return true;
        }
}
export default isEmail


// WEBPACK FOOTER //
// ./src/dev/validation/isEmail.js